import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';
import { mapMeetingFromApi } from './meetingsApi';

export async function fetchMemberMeetings() {
  const res = await fetch(`${API_BASE}/api/member/meetings`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الاجتماعات'));
  return (Array.isArray(data) ? data : []).map(mapMeetingFromApi);
}
